import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";

const AssignProcedure = () => {
  // Dummy account names (you can replace with dynamic data later)
  const accounts = [
    "37 Dental and Implant Centre",
    "Abacus Dental and Implant Clinic",
    "abc (Retiner)",
    "Adrian Popovici",
    "Affinity Dental Clinic Basildon",
    "Alaska House Dental Practice",
    "ALL SAINTS DENTAL",
    "Ameer Ali",
    "Andrew Lee (Diu Resh)",
    "Andrew Lee Dental (Bardha Jas)",
    "Andrew Lee Dental (Roebuck Louise)",
    "Andrew Lee Dental (T Hyare)",
    "Argo Dental Practice",
    "Arminder Sohal (111 Sandwell Road)",
  ];

  // State for selected procedure group and checked accounts
  const [selectedProcedure, setSelectedProcedure] = useState("");
  const [selectedAccounts, setSelectedAccounts] = useState(
    accounts.reduce((acc, account) => ({ ...acc, [account]: false }), {})
  );

  // Handle procedure group selection
  const handleProcedureChange = (event) => {
    setSelectedProcedure(event.target.value);
  };

  // Handle checkbox change
  const handleCheckboxChange = (account) => {
    setSelectedAccounts((prev) => ({
      ...prev,
      [account]: !prev[account],
    }));
  };

  // Handle Save button click
  const handleSave = () => {
    const selected = Object.keys(selectedAccounts).filter(
      (account) => selectedAccounts[account]
    );
    if (!selectedProcedure) {
      alert("Please select a procedure group.");
      return;
    }
    if (selected.length === 0) {
      alert("Please select at least one account.");
      return;
    }
    const savedData = {
      procedureGroup: selectedProcedure,
      accounts: selected,
    };

  };

  return (
    <>
      <Header />
      <Navvbar />
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          {/* Sidebar Navigation from CaseSetting */}
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-md-10">
            <div
              style={{
                fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                padding: "20px 40px",
                backgroundColor: "#fff",
              }}
            >
              {/* Page Title */}
              <h2
                style={{
                  color: "#000000",
                  fontWeight: "600",
                  marginBottom: "10px",
                  fontSize: "24px",
                }}
              >
                Assign Procedure Group To Accounts
              </h2>

              {/* Procedure Groups Section */}
              <div style={{ marginBottom: "25px" }}>
                <p
                  style={{
                    color: "#000000",
                    fontSize: "18px",
                    margin: "0",
                    padding: "0 0 2px 0",
                    textDecoration: "none",
                    cursor: "pointer",
                    display: "inline-block",
                    fontWeight: "600",
                  }}
                >
                  Procedure Groups
                </p>
                <div
                  style={{
                    borderBottom: "2px solid #004aad",
                    width: "100%",
                    margin: "0",
                  }}
                ></div>

                <div
                  style={{
                    backgroundColor: "#f1f1f1",
                    padding: "20px",
                    borderRadius: "4px",
                    marginTop: "0px",
                  }}
                >
                  <label
                    style={{
                      fontWeight: "600",
                      color: "#000",
                      display: "inline-block",
                      marginRight: "15px",
                      fontSize: "15px",
                    }}
                  >
                    Procedure Group <span style={{ color: "red" }}>*</span>
                  </label>

                  <select
                    value={selectedProcedure}
                    onChange={handleProcedureChange}
                    style={{
                      padding: "6px 10px",
                      border: "1px solid #ccc",
                      borderRadius: "3px",
                      fontSize: "14px",
                      outline: "none",
                      width: "230px",
                    }}
                  >
                    <option value="">Select Procedure Group</option>
                    <option value="IMPLANTS">IMPLANTS</option>
                    <option value="Retainer">Retainer</option>
                  </select>
                </div>
              </div>

              {/* Accounts Section */}
              <div>
                <p
                  style={{
                    color: "#000000",
                    fontSize: "18px",
                    margin: "0",
                    padding: "0 0 2px 0",
                    fontWeight: "600",
                    display: "inline-block",
                  }}
                >
                  Accounts
                </p>
                <div
                  style={{
                    borderBottom: "2px solid #004aad",
                    width: "100%",
                    margin: "0",
                  }}
                ></div>

                <div
                  style={{
                    backgroundColor: "#f1f1f1",
                    padding: "20px 30px",
                    borderRadius: "4px",
                    marginTop: "0px",
                  }}
                >
                  {accounts.map((acc, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        maxWidth: "600px",
                        marginBottom: "8px",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#000",
                          fontSize: "15px",
                          lineHeight: "1.6",
                        }}
                      >
                        {acc}
                      </span>
                      <input
                        type="checkbox"
                        checked={selectedAccounts[acc]}
                        onChange={() => handleCheckboxChange(acc)}
                        style={{
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  ))}
                  <button
                    onClick={handleSave}
                    style={{
                      backgroundColor: "#004aad",
                      border: "none",
                      borderRadius: "4px",
                      padding: "8px 16px",
                      color: "#fff",
                      fontSize: "14px",
                      cursor: "pointer",
                      marginTop: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <span role="img" aria-label="save" style={{ marginRight: "5px" }}>
                      ✎
                    </span>{" "}
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignProcedure;